import { getImageByURLAPI } from "./api-declaration";

export const getImageByURL = async (url: string): Promise<string> => {
  const image = await getImageByURLAPI(url);
  return URL.createObjectURL(image);
};
